import { Box } from '@chakra-ui/react';
import React from 'react';

function Spinner() {
  return <Box className="lds-hourglass"></Box>;
}

export default Spinner;
